import { ReactNode } from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import environment from '@lib/environment';
import DiagnosticsModule from '@modules/DiagnosticsModule';
import strings from '../strings';

type Props = {
  children?: ReactNode;
};

// Try to configure LaunchDarkly, but if it throws an error fall back to the
// baseline no-op provider, so the app doesn't fail to a blank screen.

let FeatureFlagProvider: React.FC<Props> = ({ children }: Props) => {
  return <>{children}</>;
};

try {
  FeatureFlagProvider = withLDProvider({
    clientSideID: environment.LAUNCH_DARKLY_CLIENT_ID,
  })(FeatureFlagProvider) as React.FC<Props>;
} catch (err) {
  DiagnosticsModule.reportBackgroundError(
    err,
    strings.errors.featureFlagInitFailure,
    {
      priority: 'direct',
    },
  );
}

export default FeatureFlagProvider;
